export const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    // app-bridge.js is now a static, render-blocking <script> in
    // public/index.html <head> (a Built for Shopify requirement, and it
    // starts the App Bridge handshake before React even mounts). If that tag
    // is present, don't inject a duplicate — App Bridge v4 defines
    // window.shopify synchronously when it executes, so its presence means
    // the script has already run; otherwise wait for the tag's own
    // load/error events (App.js's 12s timeout still covers a hung load).
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (window.shopify || existing.dataset.loaded === 'true') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => {
        existing.dataset.loaded = 'true';
        resolve();
      });
      existing.addEventListener('error', () =>
        reject(new Error(`Failed to load script: ${src}`))
      );
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
};
